<ul class="sub-menu-v2 active">
    <app-sidebar2-checkbox
        *ngIf="statuses.length > 0"
        [statuses]="statuses"
        [settingsFlag]="'NavigationV2Clients'"
        defaultRoute="/customers/list"
        [routeParam]="'type'"></app-sidebar2-checkbox>
</ul>
